import React from "react";
import { IMG } from "../lib/constants";
import { Coffee, Leaf, Mountain } from "lucide-react";

export default function CoffeeEstate() {
    return (
        <section id="estate" className="relative py-24 md:py-36 bg-cream" data-testid="coffee-estate-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-5">
                    <p className="text-xs tracking-[0.3em] uppercase text-forest-700 mb-6">Our Signature</p>
                    <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-coffee-900 leading-tight">
                        Wake up <span className="italic text-forest-700">inside the estate.</span>
                    </h2>
                    <p className="mt-6 text-stone-700 text-base md:text-lg leading-relaxed">
                        Veeras isn't <em>next to</em> a coffee &amp; pepper plantation — it's
                        woven right <span className="text-forest-700 font-medium">into one,</span>{" "}
                        surrounded by lush greenery on every side. Robusta shade-trees line the gentle
                        paths to your cottage — itself a vintage-rustic build of bullock-cart wheels and
                        mud blocks. Morning mist drifts slowly across the rows, carrying the call
                        of the day's first birds.
                    </p>
                    <p className="mt-4 text-stone-600 text-base md:text-lg leading-relaxed">
                        Somewhere in the green, the gentle hum of estate life unfolds — while
                        you sip a cup brewed from beans grown on this very land.
                    </p>
                    <div className="mt-6 p-5 bg-forest-700/5 border-l-2 border-forest-700/40 rounded-r-lg">
                        <p className="text-coffee-800 text-sm md:text-base leading-relaxed">
                            <span className="font-medium text-forest-700">A small wonder of Sakleshpur:</span>{" "}
                            the Western Ghats hold over <span className="font-medium">3,000 plant species</span> —
                            of which nearly <span className="font-medium">1,500 grow only here.</span> One of the
                            world's richest biological harbours, right outside your window.
                        </p>
                    </div>
                    <div className="mt-5 flex flex-col sm:flex-row gap-3 text-xs tracking-wide" data-testid="estate-travel">
                        <span className="inline-flex items-center gap-2 px-3 py-2 bg-cream border border-sand rounded-full text-coffee-700">
                            <span className="font-medium">215 km</span> · National Highway from Bengaluru
                        </span>
                        <span className="inline-flex items-center gap-2 px-3 py-2 bg-cream border border-sand rounded-full text-coffee-700">
                            <span className="font-medium">2 km</span> · Sakleshpur Railway &amp; Bus Stand
                        </span>
                    </div>
                </div>

                <div className="lg:col-span-7 grid grid-cols-6 grid-rows-6 gap-4 h-[520px] md:h-[620px]">
                    <div className="col-span-4 row-span-4 relative overflow-hidden rounded-2xl group bg-forest-900">
                        <img src={IMG.coffeeEstate} alt="Veeras coffee estate" className="absolute inset-0 h-full w-full object-cover object-center group-hover:scale-105 transition-transform duration-[1200ms]" />
                        <div className="absolute bottom-4 left-4 bg-cream/95 text-coffee-900 px-4 py-2 text-xs tracking-widest uppercase rounded">
                            Our plantation
                        </div>
                    </div>
                    <div className="col-span-2 row-span-4 relative overflow-hidden rounded-2xl group">
                        <img src={IMG.coffeeCup} alt="Estate-brewed coffee" className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                    </div>
                    <div className="col-span-3 row-span-2 relative overflow-hidden rounded-2xl group">
                        <img src={IMG.estatePath2} alt="Coffee plantation pathway" className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                    </div>
                    <div className="col-span-3 row-span-2 relative overflow-hidden rounded-2xl group">
                        <img src={IMG.cottagePath2} alt="Cottage pathway through the estate" className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                    </div>
                </div>
            </div>
        </section>
    );
}
